import React from "react"
import { Wrapper, Header, Footer, Main, IconDefs } from "./components"
import { DrawerProvider } from "./contexts"

import "fontsource-inter/300.css"
import "fontsource-inter/400.css"
import "fontsource-inter/500.css"
import "fontsource-inter/600.css"
import "fontsource-inter/700.css"

export default function App({ element }) {
  return (
    <>
      <Wrapper>
        <DrawerProvider>
          <Header />
        </DrawerProvider>
        <Main>{element}</Main>
        <Footer />
      </Wrapper>
      <IconDefs />
    </>
  )
}
